let apiBase = process.env.SERVER_URL;

if (process.env.NODE_ENV === "development") {
    apiBase = process.env.API_SERVER_URL || process.env.SERVER_URL;
}

export default {
    LOGIN: process.env.SERVER_URL + process.env.AUTH_URI,
    LOGOUT: process.env.SERVER_URL + process.env.LOGOUT_URI,
    API: apiBase + process.env.API_URI,
};



// WEBPACK FOOTER //
// ./app/urls.js